// Investor Testimonials - Adapted from iAngels.com style

export const testimonials = [
  {
    id: 1,
    name: "David Cohen",
    title: "Tech Entrepreneur & Angel Investor",
    location: "Tel Aviv, Israel",
    avatar: "https://ui-avatars.com/api/?name=David+Cohen&background=4F46E5&color=fff&size=200",
    quote: "Angels67 has democratized access to Israeli innovation. The platform's due diligence is thorough, and the investment process is seamless. I've already seen strong returns from my portfolio.",
    rating: 5,
    investmentCount: 12,
    memberSince: "2024"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    title: "Former VC Partner",
    location: "New York, USA",
    avatar: "https://ui-avatars.com/api/?name=Sarah+Johnson&background=10B981&color=fff&size=200",
    quote: "What impressed me most is the quality of deal flow and the transparency. Angels67 gives me access to deals I wouldn't see otherwise, with institutional-grade research and support.",
    rating: 5,
    investmentCount: 8,
    memberSince: "2024"
  },
  {
    id: 3,
    name: "Michael Chen",
    title: "Software Executive",
    location: "San Francisco, USA",
    avatar: "https://ui-avatars.com/api/?name=Michael+Chen&background=F59E0B&color=fff&size=200",
    quote: "The team at Angels67 is exceptional. They've built a community of smart investors and provide ongoing support. My portfolio is diversified across cutting-edge Israeli tech companies.",
    rating: 5,
    investmentCount: 15,
    memberSince: "2023"
  },
  {
    id: 4,
    name: "Rachel Goldstein",
    title: "Healthcare Investor",
    location: "London, UK",
    avatar: "https://ui-avatars.com/api/?name=Rachel+Goldstein&background=EF4444&color=fff&size=200",
    quote: "I specifically chose Angels67 for their HealthTech and AI expertise. The platform's research on medical technology companies is outstanding, and I've invested in several promising startups.",
    rating: 5,
    investmentCount: 6,
    memberSince: "2024"
  },
  {
    id: 5,
    name: "Thomas Weber",
    title: "Private Equity Investor",
    location: "Berlin, Germany",
    avatar: "https://ui-avatars.com/api/?name=Thomas+Weber&background=8B5CF6&color=fff&size=200",
    quote: "Angels67 offers the perfect blend of hands-on investing and professional guidance. The managed portfolio option allowed me to build a diversified fund tailored to my risk profile.",
    rating: 5,
    investmentCount: 20,
    memberSince: "2023"
  },
  {
    id: 6,
    name: "Lisa Zhang",
    title: "Family Office Manager",
    location: "Singapore",
    avatar: "https://ui-avatars.com/api/?name=Lisa+Zhang&background=06B6D4&color=fff&size=200",
    quote: "Managing our family office's venture portfolio through Angels67 has been transformative. The platform provides transparency, quality deal flow, and excellent investor relations.",
    rating: 5,
    investmentCount: 25,
    memberSince: "2023"
  }
];

export const testimonialStats = {
  averageRating: 4.9,
  totalReviews: 342,
  satisfactionRate: 98,
  repeatInvestorRate: 87
};

export default testimonials;
